import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { SignIn } from "@clerk/clerk-react";
import { FileText } from "lucide-react";
import { DEV_AUTH_ENABLED, DEV_USERS, findDevUser, setDevAuth } from "@/lib/devAuth";
import { Button } from "@/components/ui/button";
import { Card, CardBody, CardHeader, CardTitle } from "@/components/ui/card";
import { Input, Label } from "@/components/ui/input";

function DevSignIn() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const user = findDevUser(email, password);
    if (!user) {
      setError("Email or password is incorrect.");
      return;
    }
    setDevAuth({ clerkUserId: user.clerkUserId, role: user.role, email: user.email });
    navigate("/");
  };

  return (
    <Card className="w-full max-w-sm">
      <CardHeader>
        <CardTitle>Sign in</CardTitle>
        <span className="rounded-full bg-warn-tint px-2.5 py-0.5 text-[11px] font-semibold text-warn-on">
          dev mode
        </span>
      </CardHeader>
      <CardBody>
        <form onSubmit={submit} className="flex flex-col gap-3">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="annick@agp.test"
              autoComplete="username"
            />
          </div>
          <div>
            <Label htmlFor="password">Password</Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
          </div>
          {error && <p className="text-[13px] font-medium text-danger-on">{error}</p>}
          <Button type="submit" className="mt-1">
            Sign in
          </Button>
        </form>
        <div className="mt-4 border-t border-border pt-3 text-[12px] leading-relaxed text-text-3">
          Dev accounts:{" "}
          {DEV_USERS.map((u) => (
            <div key={u.clerkUserId}>
              {u.email} / {u.password}
            </div>
          ))}
        </div>
      </CardBody>
    </Card>
  );
}

export function SignInPage() {
  return (
    <div className="flex min-h-full flex-col items-center justify-center gap-6 p-6">
      <div className="flex items-center gap-2.5">
        <span className="flex h-9 w-9 items-center justify-center rounded-md bg-brand-500 text-text-on-brand">
          <FileText size={19} />
        </span>
        <span className="font-display text-xl font-bold tracking-tight text-text">
          AGP Resume Formatter
        </span>
      </div>
      {DEV_AUTH_ENABLED ? <DevSignIn /> : <SignIn routing="hash" forceRedirectUrl="/" />}
    </div>
  );
}
